module.exports = __webpack_public_path__ + "assets/img/reverse-sweep-1.dd167934.png";